import { SidebarDataService } from './shared/sidebar.data.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorage } from 'ngx-webstorage';
import { AuthenticationService } from '../../authentication/authentication.service';
import { environment } from './../../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Const } from '@app/shared';
import { Iframe } from '../../../shared/models/iframe.model';
import { Helps } from '@app/shared/models/helps.model';

@Component({
  selector: 'iw-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [SidebarDataService]
})
export class SidebarComponent implements OnInit {
  @SessionStorage() sidebarCollapse: boolean;
  integrationCita = Const.INTEGRACION_CITA;

  iframes: Iframe[] = [];;

  collapseMenu = {
    home: false,
    examples: false,
    indicators: false,
    reports: false,
    utilidadesExternas: false,
    utilidades: false
  };
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    administration: false,
    reportsInstance: false,
    indicatorInstance: false,
    helps: false
  };

  // definine la visualizacion de la opcion de utilidades
  utilidades = {
    cuadroRetencionDocumental: false
  };

  // define las opciones de utilidades


  // Atajo a las configuraciones del entorno de ejecución
  env = environment;
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;

  constructor(
    private router: Router,
    private as: AuthenticationService,
    private sbds: SidebarDataService
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    if (environment.ValoracionDocumental){
      this.utilidades.cuadroRetencionDocumental = true;
    }
    if (environment.Helps) {
      this.activateAction.helps = true;
    }
    const credentials = this.as.getCredentials();
    if (credentials.permisos && credentials.permisos.length) {
      for (const permission of credentials.permisos) {
        if (
          permission.permiso === Const.types_permissions.administrationForms ||
          permission.permiso === Const.types_permissions.administrationGroupsPermissions ||
          permission.permiso === Const.types_permissions.administrationHoliDays ||
          permission.permiso === Const.types_permissions.administrationMasterTables ||
          permission.permiso === Const.types_permissions.administrationProcess ||
          permission.permiso === Const.types_permissions.administrationUtilities ||
          permission.permiso === Const.types_permissions.administrationReports ||
          permission.permiso === Const.types_permissions.administrationSystem
        ) {
          this.activateAction.administration = true;
          break;
        }
      }
    }
    this.activateAction.reportsInstance = this.as.confirmPermission(
      Const.types_permissions.reportsInstance,
      Const.types_action_permissions.generateReport,
    );
    this.activateAction.indicatorInstance = this.as.confirmPermission(
      Const.types_permissions.indicatorInstance,
      Const.types_action_permissions.review,
    );
    this.sbds.getIframes().subscribe(res => {
      this.iframes = res;
    });

  }

  /**
   * Muestra y oculta el menú del sidebar.
   *
   * @memberof SidebarComponent
   */
  toggleMenu(collapse?: boolean) {
    switch (collapse) {
      case true:
        this.sidebarCollapse = true;
        break;
      case false:
        this.sidebarCollapse = false;
        break;
      default:
        this.sidebarCollapse = !this.sidebarCollapse;
        this.resetSubMenuState();
        break;
    }
  }

  /**
   * Cambia el estado de todos los desplegables a false,
   * por ende se ocultan.
   *
   * @memberof SidebarComponent
   */
  resetSubMenuState() {
    for (const key in this.collapseMenu) {
      if (this.collapseMenu.hasOwnProperty(key)) {
        this.collapseMenu[key] = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/shell/sidebar/sidebar.component.ts